const PREFETCH = [
  "https://wildcraft.com",
  "https://www.googletagmanager.com",
  "https://www.google-analytics.com",
];

const FONTS = [
  "https://static-wildcraft.omuni.com/fonts/stagsansmedium/StagSans-Medium.woff2",
  "https://static-wildcraft.omuni.com/fonts/stagsansbook/StagSans-Book.woff2",
  "https://static-wildcraft.omuni.com/fonts/wildbrush/Wild-Brush.woff2",
  "https://static-wildcraft.omuni.com/fonts/icomoon/icomoon.woff?shfbaf",
];
const SITE_COLOR = "#e65300";

const FAVICON = "https://static-wildcraft.omuni.com/icon48.png";

export default { PREFETCH, FONTS, SITE_COLOR, FAVICON };
